import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        main: {
            mx: 'auto',
            width: '100%',
        },
        container: {
            width: '100%',
            justifyContent: {base: 'center', xl: 'flex-start'},
            alignItems: {base: 'center', xl: 'flex-start'},
        },
        imageContainer: {
            w: '100%',
            maxW: {base: '100%', md: remCalc(598), lg: remCalc(810), xl: remCalc(1067)},
            mb: {base: remCalc(24), xl: 0},
        },
        image: {
            width: '100%',
        },
        productsContainer: {
            maxW: {base: '100%', xl: remCalc(508)},
            mx: 'auto',
            alignSelf: 'stretch',
            px: {xl: remCalc(24)},
        },
        textblockContainer: {
            gap: remCalc(16),
            mb: remCalc(16),
            textAlign: 'center',
        },
        label: {
            textTransform: 'uppercase',
            color: 'text.secondary',
        },
        slider: {
            maxW: {base: '100%', md: remCalc(315), lg: remCalc(422), xl: '100%'},
            mx: {base: 'auto', xl: 0},
            height: {xl: '100%'},

            '.stp-swiper': {
                height: {xl: '100%'},
            },
        },
        tile: {
            alignItems: 'center',
            textAlign: 'center',
            height: {xl: '100%'},
            justifyContent: 'flex-start',
            gap: remCalc(8),
        },
        tileElem: {
            alignItems: 'center',
        },
        productImage: {
            maxW: {base: remCalc(226), md: remCalc(230), lg: remCalc(310), xl: remCalc(332)},
            h: 'auto',
            display: 'inline',
            mb: remCalc(16),
        },
        productId: {
            textTransform: 'uppercase',
            color: 'text.secondary',
            mb: remCalc(4),
        },
        omnibusPrice: {
            color: 'text.secondary',
        },
        omnibusPercentage: {
            color: 'text.secondary',
            ml: remCalc(4),
        },
        chevronIcon: {
            width: remCalc(36),
            height: remCalc(36),
            color: 'background.neutral.grey',
            bg: 'background.base.overlay',
            boxShadow: 'borderShadow',
            backdropFilter: 'blur(5px)',
            border: 'small',
            borderColor: 'border.neutral.highlight',
            borderStyle: 'solid',
            borderRadius: 'full',
            cursor: 'pointer',
            zIndex: 10,
            position: 'absolute',
            top: {base: remCalc(113), lg: remCalc(150), xl: remCalc(166)},
            transform: 'translateY(-50%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
    },
}
